export default {
  id: '108b8c6161',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page onboarding-page" data-name="onboarding">\n        <div class="page-content">\n            <div class="onboard-skip">\n                <a href="/mobileVerification/" class="link">Skip</a>\n            </div>\n            <div data-pagination=\'{"el": ".swiper-pagination"}\' class="swiper-container swiper-init onboard-swiper">\n                <div class="swiper-wrapper">\n                    <div class="swiper-slide">\n                        <div class="onboard-slide">\n                            <div class="onboard-image">\n                                <img src="static/img/s1r.svg" alt="">\n                            </div>\n                            <div class="onboard-text">\n                                <span class="onboard-title">No more waiting</span>\n                                <span class="onboard-sub">Book appointments with top doctors in seconds</span>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="swiper-slide">\n                        <div class="onboard-slide">\n                            <div class="onboard-image">\n                                <img src="static/img/s2r.svg" alt="">\n                            </div>\n                            <div class="onboard-text">\n                                <span class="onboard-title">Care, all in one place</span>\n                                <span class="onboard-sub">Doctors, lab tests, blood bank &amp; more</span>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="swiper-slide">\n                        <div class="onboard-slide">\n                            <div class="onboard-image">\n                                <img src="static/img/s3r.svg" alt="">\n                            </div>\n                            <div class="onboard-text">\n                                <span class="onboard-title">Hassle-free appointments</span>\n                                <span class="onboard-sub">Track bookings and manage your family\'s health</span>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="swiper-pagination"></div>\n            </div>\n            <div class="onboard-cta">\n                <a href="/mobileVerification/">\n                    <button class="onboard-btn">Get Started</button>\n                </a>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  style: `
    .onboarding-page,
[data-f7-108b8c6161] .onboarding-page .page-content {
        background: var(--mdoc-white);
    }
[data-f7-108b8c6161] .onboard-skip {
        position: absolute;
        top: calc(12px + var(--f7-safe-area-top));
        right: 16px;
        z-index: 10;
    }
[data-f7-108b8c6161] .onboard-skip a {
        display: inline-block;
        padding: 7px 16px;
        border-radius: 999px;
        background: var(--mdoc-surface-1);
        color: var(--mdoc-muted);
        font-size: 13px;
        font-weight: 700;
        text-decoration: none;
    }
[data-f7-108b8c6161] .onboard-swiper {
        height: calc(100% - 96px);
        width: 100%;
    }
[data-f7-108b8c6161] .onboard-slide {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding: 60px 28px 40px;
        box-sizing: border-box;
    }
[data-f7-108b8c6161] .onboard-image {
        text-align: center;
        margin-bottom: 36px;
    }
[data-f7-108b8c6161] .onboard-image img {
        width: 78%;
        max-width: 320px;
        height: auto;
    }
[data-f7-108b8c6161] .onboard-text {
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
[data-f7-108b8c6161] .onboard-title {
        font-size: 24px;
        font-weight: 800;
        color: var(--mdoc-ink);
        line-height: 1.25;
    }
[data-f7-108b8c6161] .onboard-sub {
        font-size: 14.5px;
        color: var(--mdoc-muted);
        line-height: 1.5;
        max-width: 300px;
        margin: 0 auto;
    }
[data-f7-108b8c6161] .onboard-swiper .swiper-pagination {
        bottom: 8px;
    }
[data-f7-108b8c6161] .onboard-swiper .swiper-pagination-bullet {
        width: 7px;
        height: 7px;
        background: var(--mdoc-border);
        opacity: 1;
        transition: width .2s ease, background .2s ease;
    }
[data-f7-108b8c6161] .onboard-swiper .swiper-pagination-bullet-active {
        width: 22px;
        border-radius: 999px;
        background: var(--mdoc-green);
    }
[data-f7-108b8c6161] .onboard-cta {
        padding: 0 16px calc(20px + var(--f7-safe-area-bottom));
    }
[data-f7-108b8c6161] .onboard-btn {
        width: 100%;
        height: 52px;
        border: none;
        border-radius: 14px;
        background: var(--mdoc-green);
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0.3px;
        box-shadow: 0 6px 16px rgba(46, 182, 125, 0.28);
    }
[data-f7-108b8c6161] .onboard-btn:active {
        background: var(--mdoc-green-dark);
    }
`,
  styleScoped: true
};